module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/logo-f78535a0a1669d6adb8d4ecc599d9ae7.png";